import React from 'react';
import T from 'prop-types';
import { FaHeart } from 'react-icons/fa';

export const MenuIcon = ({ active }) => {
    return <FaHeart className={'menuIconCls'} color={active ? '#E3031F' : '#666666'} />;
};

MenuIcon.T = {
    active: T.bool,
};

MenuIcon.defaultProps = {
    active: false
};
